// extracted by mini-css-extract-plugin
export default {"root":"cqD7yc","label":"agVscQ","button":"xs6NQE","icon":"CtP7dN"};